export default "__VITE_ASSET__5d91f55d__"